export function mock(adapter) {
  adapter.onGet('/somedata').reply(function(config) {
    return [200, { somedata: require('../data/app.js').default.somedata } ]
  })
}


// WEBPACK FOOTER //
// ./src/api/mock/requests/app.js